import * as PropTypes from "prop-types"
import { I18n } from "react-polyglot-hooks"
import { parseMDX } from "lib/mdx"
import LegalScene from "scenes/LegalScene"
import common from "../../i18n/it/common"
import markdown from "../../i18n/it/legal/terms.md"

export default function TerminiCondizioni({ content }) {
  return (
    <I18n locale="it" phrases={{ ...common }}>
      <LegalScene page="terms" markdown={content} />
    </I18n>
  )
}

TerminiCondizioni.propTypes = {
  content: PropTypes.string.isRequired
}

export async function getStaticProps() {
  const parsedMdx = await parseMDX(markdown)
  return { props: { content: parsedMdx } }
}
